export default "__VITE_ASSET__a73822f1__"